module.exports = __webpack_public_path__ + "media/mypage/images/sparkle-fluid-icon-7cad09629a2a0c534b3f728ceababefa.png";